<template>
  <div class="content">
    <h4 class="title">花城{{ monthObj[currentMOnth] || 0 }}月赏花地图</h4>
    <div class="img" @click="openMap"></div>
    <div class="tip">点击图片查看详细内容</div>
  </div>
</template>

<script>
// <img src="@/assets/image/partMap.jpg" alt="花城赏花地图" />
export default {
  data() {
    return {
      monthObj: {
        1: '一',
        2: '二',
        3: '三',
        4: '四',
        5: '五',
        6: '六',
        7: '七',
        8: '八',
        9: '九',
        10: '十',
        11: '十一',
        12: '十二'
      },
      currentMOnth: 0
    }
  },
  mounted() {
    this.currentMOnth = new Date().getMonth() + 1
    document.title = `花城${this.monthObj[this.currentMOnth] || 0}月赏花地图`
  },
  methods: {
    openMap() {
      this.$router.push({ path: '/allFlowerMap' })
    }
  }
}
</script>

<style lang="scss" scoped>
@use 'sass:math';
@media screen and (min-width: 350px) and (max-width: 1200px) {
  $designWidth: 1080;
  $designHeight: 1920;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    width: getVw(1080);
    height: getVh(1920);
    padding: getVw(80) getVw(40) getVw(100);
    box-sizing: border-box;
    background-color: #d9ecd9;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    .title {
      font-size: getVh(80);
      line-height: getVh(80);
      margin-bottom: getVh(100);
      color: #b86f4f;
      font-weight: 700;
    }
    .img {
      width: getVw(960);
      height: getVh(1420);
      background: url(https://weixin.gzyks.com/webapp/applet/ecological_index/map.jpg);
      background-size: cover;
      background-position: left bottom;
      background-repeat: no-repeat;
      margin-bottom: getVh(100);
    }
    .tip {
      font-size: getVh(50);
      line-height: getVh(50);
      cursor: pointer;
    }
  }
}
@media screen and (min-width: 1201px) and (max-width: 4000px) {
  $designWidth: 1920;
  $designHeight: 1080;
  @function getVw($px) {
    @return math.div($px, $designWidth) * 100vw;
  }
  @function getVh($px) {
    @return math.div($px, $designHeight) * 100vh;
  }
  .content {
    padding: getVw(60) getVw(40) getVw(100);
    box-sizing: border-box;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #d9ecd9;
    .title {
      font-size: getVh(80);
      margin-bottom: getVh(80);
      color: #b86f4f;
      font-weight: 700;
    }
    .img {
      width: getVw(960);
      height: getVh(1420);
      background: url(https://weixin.gzyks.com/webapp/applet/ecological_index/map.jpg);
      background-size: cover;
      background-position: left bottom;
      background-repeat: no-repeat;
      margin-bottom: getVh(40);
    }
    .tip {
      font-size: getVh(50);
      margin-top: getVh(40);
      cursor: pointer;
    }
  }
}
</style>
